import React from "react";

function PageTitle(props: Readonly<{ title: string }>) {
  return (
    <div>
      <h1 className=" text-4xl md:text-5xl font-bold text-center md:text-left mb-8
              transition-all duration-700">
        {props.title}
      </h1>
    </div>
  );
}

export default PageTitle;
